export default __webpack_public_path__ + "static/media/self-employed.147ac8fe.svg";